import { N20 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

export const HEADER_BACKGROUND_COLOR = token('elevation.surface.sunken', N20); // TODO: fix token https://hello.atlassian.net/wiki/spaces/ADOS/pages/1511543981/Dark+Mode+Mismatched+Colors+on+Roadmaps+issue+epic-color
